import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../../network/apis/api";
import { endpoints } from "../../../Accounts/store/endpoints";
import * as whatsAppAccountListActions from "../actions/whatsapp_account_list_actions";
import * as whatsAppAccountListTypes from "../types/whatsapp_account_list_types";
import { dispatchSnackbarError } from "../../../../utils/toaster";

function* getListOfWhatsAppAccounts(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_WHATSAPP_ACCOUNT_LIST, action.payload);
    if (res.status === 200) {
      yield put(whatsAppAccountListActions.getListOfWhatsAppAccountsSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(whatsAppAccountListActions.getListOfWhatsAppAccountsError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(whatsAppAccountListActions.getListOfWhatsAppAccountsError(e));
  }
}

function* getCountOfWhatsAppAccounts(action) {
  try {
    const res = yield call(api.get, endpoints.SUPER_ADMIN_WHATSAPP_ACCOUNT_COUNT, action.payload);
    if (res.status === 200) {
      yield put(whatsAppAccountListActions.getCountOfWhatsAppAccountsSuccess(res.data));
    } else {
      dispatchSnackbarError(res.data.message);
      yield put(whatsAppAccountListActions.getCountOfWhatsAppAccountsError(res.data));
    }
    if (action.cb) action.cb(res.data);
  } catch (e) {
    yield put(whatsAppAccountListActions.getCountOfWhatsAppAccountsError(e));
  }
}

export default function* whatsAppAccountListSaga() {
  yield takeLatest(whatsAppAccountListTypes.getListOfWhatsAppAccounts.GET_LIST_OF_WHATSAPP_ACCOUNTS_REQUEST, getListOfWhatsAppAccounts);
  yield takeLatest(whatsAppAccountListTypes.getListOfWhatsAppAccounts.GET_COUNT_OF_WHATSAPP_ACCOUNTS_REQUEST, getCountOfWhatsAppAccounts);
}
